module.exports = __webpack_public_path__ + "static/media/Momo.ccf6ffa5.svg";